import React, { forwardRef, Ref, SVGProps } from 'react'

function _IconLink(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" {...props} ref={ref}>
      <path
        d="M5.8335 8.08494C6.08401 8.41985 6.40362 8.69696 6.77065 8.89749C7.13768 9.09801 7.54354 9.21726 7.96071 9.24714C8.37788 9.27701 8.79659 9.21682 9.18845 9.07065C9.58031 8.92447 9.93615 8.69573 10.2318 8.39994L11.9818 6.64994C12.5131 6.09985 12.8071 5.36309 12.8005 4.59835C12.7938 3.83361 12.4871 3.10208 11.9463 2.5613C11.4055 2.02053 10.674 1.71379 9.90925 1.70714C9.14451 1.7005 8.40775 1.99448 7.85766 2.52577L6.85433 3.52327"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16678 6.91574C7.91627 6.58083 7.59666 6.30372 7.22963 6.10319C6.8626 5.90267 6.45674 5.78342 6.03957 5.75355C5.6224 5.72367 5.20369 5.78386 4.81183 5.93003C4.41997 6.07621 4.06413 6.30495 3.76845 6.60074L2.01845 8.35074C1.48716 8.90083 1.19317 9.63759 1.19982 10.4023C1.20646 11.1671 1.51321 11.8986 2.05398 12.4394C2.59475 12.9802 3.32629 13.2869 4.09103 13.2935C4.85577 13.3002 5.59253 13.0062 6.14262 12.4749L7.14012 11.4774"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const IconLink = forwardRef(_IconLink)
